var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",on:{"click":_vm.handleClick}},[_c('img',{staticClass:"card-img",attrs:{"src":_vm.data.url}}),_c('div',{staticClass:"card-text"},[_vm._v(" "+_vm._s(_vm.data.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }